import classNames from "classnames";

export default function ContentText({ children, classes = "" }) {
  const defaultClasses = "text-lg text-gray-700 mb-4";

  let paragraphs = [];
  if (Array.isArray(children)) {
    paragraphs = children;
  } else {
    paragraphs = children.split(/\n\s*\n/);
  }

  return (
    <>
      {paragraphs.map((para, index) => (
        <p key={index} className={classNames(defaultClasses, classes)}>
          {para}
        </p>
      ))}
    </>
  );
}
